import { supabase } from '@/lib/supabase'

export const getPublicProjects = async () => {
  const portfolioRes = await supabase
    .from('portfolio_projects')
    .select('*')
    .eq('is_public', true)
    .order('sort_order', { ascending: true })
    .order('created_at', { ascending: false })
    .limit(1000)

  if (portfolioRes.error) {
    console.error('getPublicProjects (portfolio):', portfolioRes.error)
  }

  const hubRes = await supabase.rpc('get_published_hub_projects')

  if (hubRes.error) {
    console.error('getPublicProjects (hub):', hubRes.error)
  }

  const portfolioRows = (portfolioRes.data || []).filter((p) => !p.status || p.status === 'published')

  const portfolioMapped = portfolioRows.map((p) => ({
    id: p.id,
    source: 'portfolio',
    title: p.title,
    excerpt: p.excerpt,
    category: p.category,
    thumbnail_url: p.thumbnail_url,
    sortKey: new Date(p.updated_at || p.created_at || 0).getTime(),
  }))

  const hubRows = hubRes.data || []
  const hubMapped = hubRows.map((r) => {
    const hero = r.display_assets?.hero_image_urls
    const thumb = Array.isArray(hero) && hero.length > 0 ? hero[0] : null
    return {
      id: `hub-${r.id}`,
      source: 'hub',
      hubSlug: r.slug,
      title: r.name,
      excerpt: r.description || '',
      category: r.category || '',
      thumbnail_url: thumb,
      sortKey: new Date(r.updated_at || r.created_at || 0).getTime(),
    }
  })

  const merged = [...portfolioMapped, ...hubMapped].sort((a, b) => b.sortKey - a.sortKey)
  return merged.map(({ sortKey, ...rest }) => rest)
}

export const getProjectById = async (id) => {
  const { data, error } = await supabase.from('portfolio_projects').select('*').eq('id', id).single()
  if (error) throw error
  return data
}
